import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AddressForm from '../AddressForm/AddressForm';


const ShippingAddress = (props) => {
    const address = props.address.streetName + " " + (props.address.home) + ' ,' + props.address.cityName;
    const selectedOtherAddress = props.showOnlyAddressForm ? true : false;
    const [isSelectedOtherAddress, setIsSelectedOtherAddress] = useState(selectedOtherAddress);

    function onClick(btnType){
        setIsSelectedOtherAddress(btnType == "otherAddress");
    }

    useEffect(() => {
      if (props.isSubmit && !isSelectedOtherAddress) {
        props.onSubmit({selectedAddress: props.address, isValid: true});
      }
    }, [props.isSubmit]);

    return (
        <div className='shipping-address'>
          {props.showOnlyAddressForm ?
          <AddressForm isSubmit={props.isSubmit} onSubmit={props.onSubmit} /> :
          <>
            <div className='option-wrapper'>
                <button className={`option-item ${!isSelectedOtherAddress ? 'selected' : ''}`}  onClick={() => onClick('userAddress')}>משלוח לכתובת: {address} </button>
                <button className={`option-item ${isSelectedOtherAddress ? 'selected' : ''}`} onClick={() => onClick('otherAddress')}>משלוח לכתובת אחרת</button>
            </div>
            {isSelectedOtherAddress &&
              <>
              <h2 className='other-address-title'>כתובת למשלוח</h2>
              <AddressForm isSubmit={props.isSubmit} onSubmit={props.onSubmit} />
              </> }
          </>
          }
        </div>
    );

};

const mapStateToProps = (state) => {
    return {
    };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ShippingAddress);
